// frontend/src/tabs/TabPane.jsx
//
// The box TabsHost puts around every tab it has mounted: on screen when
// `active`, otherwise hidden with `display: none` but still mounted, so the
// tab keeps its React state, its DOM, its effects and its refs. A widget that
// lives outside React — an AG Grid, built and destroyed from a ref callback —
// is the SAME instance when the merchant comes back
// (tabPaneGridLifecycle.test.jsx).
//
// The visible pane is `display: contents`, which produces no box of its own
// (https://developer.mozilla.org/en-US/docs/Web/CSS/display-box): the page's
// boxes sit in the scroll container as if the pane were not there.
//
// A hidden tab's effects run as they would on screen; what should wait for
// the tab to come back reads `useTabActive()` (tabsContexts.js).

import { TabActiveContext } from './tabsContexts';

export function TabPane({ active, children }) {
  return (
    <TabActiveContext.Provider value={active}>
      <div style={{ display: active ? 'contents' : 'none' }}>{children}</div>
    </TabActiveContext.Provider>
  );
}
